import { type ISupportedLanguage } from "#app/utils/i18n.tsx";

export class Profession {
  static readonly ARCHITECT = new Profession(1, {
    en: "Architect/Designer",
    it: "Architetto/Designer",
    de: "Architekt/Designer",
    fr: "Architecte/Designer",
    es: "Arquitecto/Diseñador",
  });

  static readonly ENGINEER = new Profession(7, {
    en: "Engineer",
    it: "Ingegnere",
    de: "Ingenieur",
    fr: "Ingénieur",
    es: "Ingeniero",
  });

  static readonly CONSTRUCTION_COMPANY = new Profession(9, {
    en: "Construction Industry",
    it: "Impresa Costruzioni",
    de: "Baufirma",
    fr: "Compagnie de construction",
    es: "Compañía de construcción",
  });

  static readonly MARBLE_WORKER = new Profession(10, {
    en: "Marble/Tile worker",
    it: "Marmista/Posatore",
    de: "Marmorarbeiter/Fliesenleger",
    fr: "Marbrier/Poseur",
    es: "Marmolista/Colocador",
  });

  static readonly PRIVATE_CONSUMER = new Profession(12, {
    en: "Private Customer",
    it: "Consumatore Privato",
    de: "Privatkunde",
    fr: "Consommateur/Particulier",
    es: "Consumidor Privado",
  });

  static readonly DEALER = new Profession(14, {
    en: "Dealer",
    it: "Rivenditore",
    de: "Händler",
    fr: "Revendeur",
    es: "Distribuidor",
  });

  private constructor(
    public readonly id: number,
    public readonly labels: {
      en: string;
      it: string;
      de: string;
      fr: string;
      es: string;
    },
  ) {}

  static getAll(): Profession[] {
    return [
      this.ARCHITECT,
      this.ENGINEER,
      this.CONSTRUCTION_COMPANY,
      this.MARBLE_WORKER,
      this.PRIVATE_CONSUMER,
      this.DEALER,
    ];
  }

  static getSelectOptions(
    locale: ISupportedLanguage,
  ): { value: string; label: string }[] {
    return this.getAll().map((profession) => ({
      value: String(profession.id),
      label: profession.labels[locale],
    }));
  }

  static getById(id: number): Profession | undefined {
    return this.getAll().find((profession) => profession.id === id);
  }
}
